type ChecklistState = {
  status: string;
  linkedEvidenceDocuments?: unknown[];
};

type AuditState = {
  createdAt: string;
  metadata?: Record<string, unknown>;
};

export function acceptedChecklistCount(items: ChecklistState[]) {
  return items.filter(item => item.status === 'accepted').length;
}

export function needsCrossDocumentClarification(item: ChecklistState) {
  return (
    item.status === 'needs_review' &&
    (item.linkedEvidenceDocuments?.length ?? 0) === 0
  );
}

export function latestGapDetectionAt(events: AuditState[]) {
  return events
    .filter(event => event.metadata?.source === 'checklist_gap_detection')
    .sort((left, right) => right.createdAt.localeCompare(left.createdAt))[0]
    ?.createdAt;
}
